import { EbMarchandise } from './marchandise';
import { EcCountry } from "./country";
import { EbAdresse } from "./adresse";


export class EbCommande {


    ebCommandeNum: number;
    transporteurPickerCode: string;
    iftstaFile: string;
    xEbImIncident: number;
    libelleCountryDest: string;
    transporteurPickerNum: number;
    transporteurPickerName: string;
    transporteurDistribNum: number;
    transporteurDistribName: string;
    camion: number;
    nbrParcel: number;
    totalWeight: number;
    volume: number;
    taxableWeight: number;
    customerReference: string;
    nbDocument: number;
    xEbPartyDest: number;
    origin: number;
    dateDeparture: Date;
    codeTransporteur: string;
    dateRealPickup: Date;
    codeRealTransporteur: string;
    xEbAdresse: EbAdresse;
    libelleTypeTransport: string;
    carrier: string;
    numberOfPickslip: number;
    carrierId: number;
    countryDest: string;
    dateReceptionIfcsum: Date;
    dateReceptionIftstat: Date;
    demandeNum: number;
    xEcStatut: number;
    libelleStatut: string;
    initialCompany: string;
    initialAddress: string;
    initialCity: string;
    initialZipCode: string;
    initialAirport: string;
    initialEmailAddress: string;
    initialContact: string;
    initialCountryCode: string;
    initialXEcCountryNum: string;
    deliveryDate: Date;
    referencePo: string;
    aboutTrAwbBol: string;
    aboutTrMawb: string;
    aboutTrFlightVessel: string;
    aboutTrCustomOffice: string;
    aboutTrEta: Date;
    aboutTrEtd: Date;
    aboutTrAta: Date;
    aboutTrPickUp: Date;
    aboutTrFinalDelivery: Date;
    listMarchandise: Array<EbMarchandise>;
    listMarchandiseStr: string;
    ffPoids1: number;
    ffPoids2: number;
    ffVolume1: number;
    ffVolume2: number;
    ffTotalWeight: number;
    ffTaxableWeight: number;
    exIncidentChargementNum: number;
    listPickslipId: string;
    xEcCountry: EcCountry;
    codeConsignee: string;
    refTransport: string;
    Email: string;
    Nom: string;
    backupEmail: string;
    totalUnits: number;


    nbNotification: number;

    constructor() {

        this.ebCommandeNum = null;
        this.transporteurPickerCode = null;
        this.iftstaFile = null;
        this.xEbImIncident = null;
        this.libelleCountryDest = null;
        this.transporteurPickerNum = null;
        this.transporteurPickerName = null;
        this.transporteurDistribNum = null;
        this.transporteurDistribName = null;
        this.camion = null;
        this.nbrParcel = null;
        this.totalWeight = null;
        this.volume = null;
        this.taxableWeight = null;
        this.customerReference = null;
        this.nbDocument = null;
        this.xEbPartyDest = null;
        this.origin = null;
        this.dateDeparture = null;
        this.codeTransporteur = null;
        this.dateRealPickup = null;
        this.codeRealTransporteur = null;
        this.xEbAdresse = null;
        this.libelleTypeTransport = null;
        this.carrier = null;
        this.numberOfPickslip = null;
        this.carrierId = null;
        this.countryDest = null;
        this.dateReceptionIfcsum = null;
        this.dateReceptionIftstat = null;
        this.demandeNum = null;
        this.xEcStatut = null;
        this.libelleStatut = null;
        this.initialCompany = null;
        this.initialAddress = null;
        this.initialCity = null;
        this.initialZipCode = null;
        this.initialAirport = null;
        this.initialEmailAddress = null;
        this.initialContact = null;
        this.initialCountryCode = null;
        this.initialXEcCountryNum = null;
        this.deliveryDate = null;
        this.referencePo = null;
        this.aboutTrAwbBol = null;
        this.aboutTrMawb = null;
        this.aboutTrFlightVessel = null;
        this.aboutTrCustomOffice = null;
        this.aboutTrEta = null;
        this.aboutTrEtd = null;
        this.aboutTrAta = null;
        this.aboutTrPickUp = null;
        this.aboutTrFinalDelivery = null;
        this.listMarchandise = new Array<EbMarchandise>();
        this.listMarchandiseStr = null;
        this.ffPoids1 = null;
        this.ffPoids2 = null;
        this.ffVolume1 = null;
        this.ffVolume2 = null;
        this.ffTotalWeight = null;
        this.ffTaxableWeight = null;
        this.exIncidentChargementNum = null;
        this.listPickslipId = null;
        this.xEcCountry = null;
        this.codeConsignee = null;
        this.refTransport = null;
        this.Email = null;
        this.Nom = null;
        this.backupEmail = null;
        this.totalUnits = null;
    }

    constructorCopy(ebCommande: EbCommande) {

    }
}



// WEBPACK FOOTER //
// ./src/app/classes/commande.ts